import { CmsExtraApplianceDetailsPage } from '../../models/extra-appliance-details/cms-extra-appliance-details-page.interface';
import { mockCmsApplianceDetailsForm } from '../appliance-details/cms-appliance-details-form.mock';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsHighlightedPartners } from './cms-highlighted-partners.mock';

export const mockCmsExtraApplianceDetailsPage: CmsExtraApplianceDetailsPage = {
  ...mockCmsRegistrationRoot,
  ...mockCmsApplianceDetailsForm,
  ...mockCmsHighlightedPartners,
  pageTitle: 'Please tell us about your appliance',
};
